export const getHeaders = () => {
  const headers: Record<string, string> = {
    'X-XSRF-TOKEN': document.cookie
      .split('; ')
      .find(row => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1] ?? ''
  };

  return headers;
};

export const handleApiError = async (response: Response): Promise<never> => {
  let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
  
  try {
    const errorData = await response.json();
    if (errorData.error) {
      errorMessage = errorData.error;
    }
  } catch (parseError) {
    try {
      const errorText = await response.text();
      if (errorText) {
        errorMessage = errorText;
      }
    } catch (textError) {
      // Fallback to status message
    }
  }
  throw new Error(errorMessage);
};

export const handleApiErrorWithBanner = async (response: Response): Promise<string> => {
  let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
  
  try {
    const errorData = await response.json();
    if (errorData.error) {
      errorMessage = errorData.error;
    }
  } catch (parseError) {
    try {
      const errorText = await response.text();
      if (errorText) {
        errorMessage = errorText;
      }
    } catch (textError) {
      // Fallback to status message
    }
  }
  
  return errorMessage;
};


export const apiFetch = async (url: string, options: RequestInit = {}) => {
  const headers = {
    ...getHeaders(),
    ...options.headers,
  };

  const fetchOptions = {
    ...options,
    credentials: 'include' as RequestCredentials,
    headers
  };

  const response = await fetch(url, fetchOptions);

  // Retry once got 401 for Windows Authentication challenge to send the credentials
  if (response.status === 401) {
    await new Promise(resolve => setTimeout(resolve, 100));
    return await fetch(url, fetchOptions);
  }

  return response;
};